import React from 'react'
import MyListBlockItem from './MyListBlockItem'

const MyListBlock = ({ text, list, className }) => {
  return (
    <div className={className ? className + ' packResultBlock' : 'packResultBlock'}>
        <p className='packResultBlock__text'>
            { text }
        </p>
        <div className='packResultBlock__list'>
            {
                list && list.length > 0 ?
                    list.map(item => {
                        return (
                            <MyListBlockItem
                                key={item.name + item.value}
                                text={item.name}
                                value={item.value}
                            />
                        )
                    })
                : ''
            }
        </div>
    </div>
  )
}

export default MyListBlock